<div class="topRight error-code" [ngClass]="{ normalError: isNormalError }">
	<p class="errorCode">
		{{ errorCode }}
	</p>
	<p class="errorMessage">{{ errorMessage | translate }}</p>

	<button
		pButton
		class="redBtn"
		type="button"
		[label]="(errorCode === 408 ? 'error.login' : 'error.back') | translate"
		[ngClass]="{ 'btn-blue': isButtonError }"
		(click)="returnToPage()"></button>
</div>
